import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiKey } from "../../config/config";
import Table from "../../components/Table";

export default function InvestorTransactions({ lang = {} }) {
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    const session = JSON.parse(sessionStorage.getItem("aman-investor") || "{}");
    const token = session.token;
    if (!token) return;

    axios
      .get(`${apiKey}/investor-panel/transactions`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setTransactions(res.data.transactions || []);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const columns = [
    {
      header: lang["SN"] || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang["Tx_ID"] || "Tx ID",
      accessorKey: "id",
      cell: (row) => <span className="fw-bold text-primary">#{row.getValue()}</span>,
    },
    {
      header: lang["Transaction_Type"] || "Transaction Type",
      accessorKey: "transaction_type",
      cell: (row) => {
        const type = row.getValue() || row.row.original.type;
        const isDep = type === "investor_deposit" || type === "deposit";
        return (
          <span className={`badge ${isDep ? "bg-success" : "bg-warning text-dark"}`}>
            {isDep ? "Deposit" : "Withdrawal"}
          </span>
        );
      },
    },
    {
      header: lang["Amount"] || "Amount (SAR)",
      accessorKey: "amount",
      cell: (row) => {
        const type = row.row.original.transaction_type || row.row.original.type;
        const isDep = type === "investor_deposit" || type === "deposit";
        return (
          <span className={`fw-bold ${isDep ? "text-success" : "text-danger"}`}>
            {isDep ? "+" : "-"} SAR {Number(row.getValue() || 0).toLocaleString()}
          </span>
        );
      },
    },
    {
      header: lang["Branch"] || "Associated Branch",
      accessorKey: "branch_name",
      cell: (row) => row.getValue() || "Main Branch",
    },
    {
      header: lang["Date_Time"] || "Date & Time",
      accessorKey: "date",
      cell: (row) => (row.getValue() ? new Date(row.getValue()).toLocaleString() : "N/A"),
    },
  ];

  return (
    <div className="container-fluid px-4 py-3">
      <div className="pagetitle mb-4">
        <h1 className="fw-bold">{lang.Transactions || "Transactions History"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">{lang.Home || "Home"}</li>
            <li className="breadcrumb-item active">{lang.Transactions || "Transactions"}</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="row pt-3">
                <div className="rr col-9">
                  {lang.Deposit_Withdrawal_History || "Deposit & Withdrawal History"}
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex mt-3 mb-3">
                  <Table
                    columns={columns}
                    data={transactions}
                    lang={lang}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
